import { useState } from 'react';
import type { OsobyPodnikatelSouhlasDto } from '@gov-nx/api';
import {
	isResponseStatus,
	rosBusinessPersonAgreementQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import { useQueryClient } from '@tanstack/react-query';
import { isValidIc } from './utils';

export const useIcSearchAutocomplete = () => {
	const [text, setText] = useState<string>();
	const { axiosInstance } = useAxiosInstance();
	const queryClient = useQueryClient();

	const buildQuery = (value: string | undefined) => ({
		queryKey: ['ic-autocomplete', value],
		queryFn: () =>
			rosBusinessPersonAgreementQuery(axiosInstance, { ico: value }),
		retry: 0,
	});

	const mainQuery = usePoQuery<OsobyPodnikatelSouhlasDto>(
		{
			...buildQuery(text),
			enabled: isValidIc(text),
			refetchOnWindowFocus: false,
		},
		{
			errorIgnoreFilter: isResponseStatus(400),
		}
	);

	return {
		isFetching: mainQuery.isFetching,
		result: mainQuery.data,
		setText,
		searchCallback: async (
			value: string
		): Promise<OsobyPodnikatelSouhlasDto[]> => {
			if (!isValidIc(value)) {
				return [];
			}

			setText(value);
			const result = await queryClient.fetchQuery(buildQuery(value));
			return result ? [result] : [];
		},
	};
};
